module.exports = __webpack_public_path__ + "static/card.f1916c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/card.png
// module id = 441
// module chunks = 114276838955818